import React from "react";
import "./ECommerce.css";
import "../Page.css";
import axios from "axios";
import { DYRUrl, security_key, Url } from "../../Services/Api";
import CustomBtn from "../../Components/UI-Controls/Buttons/Btn";
import { FaHandHoldingUsd, FaTimesCircle, FaClipboardList, FaShippingFast, FaUserPlus, FaShoppingCart } from "react-icons/fa";
import OrderViewCard from "../../Components/ECommerceComponents/OrderViewCard";
import actionIcon from "../../Assets/Images/ActionBtn 30 x 30.png";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import { useState, useEffect, useRef } from "react";
import Pagination from "../../Components/UI-Controls/Pagination/PaginationRashid";
import ElipticalPagenation from "../../Components/UI-Controls/Pagination/Pagination2";
import InputField from "../../Components/UI-Controls/InputField/InputField";
import CustomDropdown from "../../Components/UI-Controls/Dropdown/dropdown";
import { DatePicker } from "antd";
import ApexChart24 from "../../Components/UI-Controls/BarGraph/BarGraph";
import { formatOrderDate } from "../../Components/UI-Controls/DateFormat/DateFormat";
import ShimmerLoader from "../../Components/UI-Controls/Loader/ShimmerLoader";
import BottomToust from "../../Components/BottomToust/BottomToust";
import { CiWarning } from "react-icons/ci";
import { IoEyeOutline } from "react-icons/io5";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import { Tooltip } from "antd";


const AllFailedOrders = () => {
  const { RangePicker } = DatePicker;
  const modalRef = useRef(null);
  const rowsPerPage = 10;
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [cardData, setCardData] = useState([]);
  const [countData, setCountData] = useState([]);
  const [avgSaleData, setAvgSaleData] = useState();
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [filtersApplied, setFiltersApplied] = useState(true);
  const [orderId, setOrderId] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [email, setEmail] = useState("");
  const [customer, setCustomer] = useState("");
  const [payMethodsOptions, setPayMethodsOptions] = useState([]);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [filtersModified, setFiltersModified] = useState(false);
  const [dateRange, setDateRange] = useState(null);
  const [originalData, setOriginalData] = useState([]);
  const [filteredData, setFilteredData] = useState(data);
  const [showMessage, setShowMessage] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [currentRowId, setCurrentRowId] = useState(null);
  const [isActive, setIsActive] = useState(false);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState(null);
  const [savedFilters, setSavedFilters] = useState(null);




  useEffect(() => {
    fetchTableData(currentPage, 100, filtersApplied ? savedFilters : null);
  }, [currentPage]);

  const handleCloseMessageModal = () => {
    setShowMessage(false);
  };

  useEffect(() => {
    if (showMessage === true) {
      const timeOut = setTimeout(() => {
        setShowMessage(false);
      }, 3000);
      return () => clearTimeout(timeOut);
    }
  }, [showMessage]);

  const fetchPaymentMethods = async () => {
    try {
      const response = await axios.get(`${Url}/api/v1/payment-methods/get-all`);
      const methods = response.data?.paymentMethods || [];
      const formattedMethods = methods.map((method) => ({
        label: method.name,
        value: method.id,
      }));
      setPayMethodsOptions(formattedMethods);

    } catch (error) {
      console.error("Error fetching payment methods:", error);
      setPayMethodsOptions([]);
    }
  };

  useEffect(() => {
    fetchPaymentMethods();
  }, []);



  const [filterLoading, setFilterLoading] = useState(false);




  const handleFilters = async () => {
    if (
      !orderId &&
      !phoneNo &&
      !customer &&
      !email &&
      !selectedMethod &&
      (!dateRange || dateRange.length !== 2)
    ) {
      setToastMessage("Kindly select or enter respective filtration value...");
      setShowMessage(true);
      return;
    }

    const queryParams = new URLSearchParams();

    if (orderId) queryParams.append("orderId", orderId);   // Use only one of orderId or _id
    if (phoneNo) queryParams.append("phone_no", phoneNo);
    if (customer) queryParams.append("name", customer);
    if (email) queryParams.append("email", email);
    if (selectedMethod) queryParams.append("payment_method", selectedMethod);
    if (dateRange?.length === 2) {
      queryParams.append("startDate", dateRange[0]);
      queryParams.append("endDate", dateRange[1]);
    }
    queryParams.append("limit",100);
    queryParams.append("status","failed");

    queryParams.append("page", 1); // Start from page 1
    const filtersObject = Object.fromEntries(queryParams.entries());
    setSavedFilters(filtersObject); // Save filters for pagination continuity

    console.log("Selected Filters:", filtersObject);

    try {
      setFilterLoading(true);
      const token = sessionStorage.getItem('authToken');
      const headers = {
        Authorization: `Bearer ${token}`,
        'x-api-key': security_key
      };

      const response = await axios.get(`${Url}/api/v1/orders/get_filters?${queryParams.toString()}`, { headers: headers });

      const filteredData = response.data.orders;
      const paginationData = response.data.pagination;

      setFilteredData(filteredData);
      setPagination(paginationData);
      setCurrentPage(1);
      setFiltersApplied(true);
      setFiltersModified(false);
    } catch (error) {
      console.error("Error fetching filtered orders:", error);
    } finally {
      setFilterLoading(false);
    }
  };



  useEffect(() => {
    if (filtersApplied && filtersModified) {
      handleFilters();
      setFiltersModified(false);
    }
  }, [
    orderId,
    phoneNo,
    email,
    selectedMethod,
    filtersApplied,
    filtersModified,
  ]);

  const handleFilterChange = (value, fieldName) => {
    if (fieldName === "orderId") {
      setOrderId(value);
    } else if (fieldName === "phoneNo") {
      setPhoneNo(value);
    } else if (fieldName === "email") {
      setEmail(value);
    }  else if (fieldName === "paymentMethod") {
      setSelectedMethod(value);
    } else if (fieldName === "date") {
      setDateRange(value);
    } else if (fieldName === "customer") {
      setCustomer(value);
    }
    setFiltersModified(true);
  };

  const handleResetFilters = () => {
    setOrderId("");
    setPhoneNo("");
    setEmail("");
    setCustomer("");
    setSelectedMethod(null);
    setDateRange(null);
    setFiltersApplied(false);
    setFiltersModified(false);
    setSavedFilters(null);
    setFiltersApplied(false)
    fetchTableData(1, 100, null,"failed");
  };

  async function fetchTableData(page = 1, limit = 100, filters = null,status='failed') {
    setLoading(true);
    setError(null);
    const token = sessionStorage.getItem('authToken');

    const headers = {
      Authorization: `Bearer ${token}`,
      'x-api-key': security_key
    };

    try {
      let query = new URLSearchParams({ page, limit,status });

      if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
          if (value) query.append(key, value);
        });
      }

      const URL = `${Url}/api/v1/orders/${filters ? "get_filters" : "get_filters"}?${query.toString()}`;

      const response = await fetch(URL, { headers: headers });
      const result = await response.json();

      const reversedOrders = result.orders;
      const cardOrdersData = result.pagination;
      const countStatusData = result.statusCounts;
      const avgSaleData = result.averageSale;

      setData(reversedOrders);
      setCardData(cardOrdersData);
      setCountData(countStatusData);
      setAvgSaleData(avgSaleData);
      setOriginalData(reversedOrders);
      setFilteredData(reversedOrders);
      setPagination(cardOrdersData);

      setToastMessage(`${filters ? "Filtered" : "All"} Orders Data have been fetched successfully!`);
      setShowMessage(true);
    } catch (error) {
      const errMsg = error?.response?.data?.message || error.message;
      setError(errMsg);
      setToastMessage(`Failed to fetch Orders Data: ${errMsg}`);
      setShowMessage(true);
    } finally {
      setLoading(false); // ✅ this will now run immediately after fetch is done
    }
  }



  // async function fetchTableData(page = 1, limit = 100) {
  //   setLoading(true);
  //   setError(null);
  //   setTimeout(async () => {
  //     try {
  //       const URL = ${Url}/api/v1/orders/get?page=${page};
  //       const response = await fetch(URL);
  //       const result = await response.json();
  //       const reversedOrders = result.orders.reverse();
  //       const cardOrdersData = result.pagination;
  //       const countStatusData = result.statusCounts;
  //       const avgSaleData = result.averageSale;
  //       setData(reversedOrders);
  //       setCardData(cardOrdersData);
  //       setCountData(countStatusData);
  //       setAvgSaleData(avgSaleData);
  //       setOriginalData(reversedOrders);
  //       setFilteredData(reversedOrders);
  //       setPagination(cardOrdersData)
  //       setToastMessage("All Orders Data have been fetched successfully!");
  //       setShowMessage(true);
  //     } catch (error) {
  //       const errMsg = error?.response?.data?.message || error.message;
  //       setError(errMsg);
  //       setToastMessage(Failed to fetch Orders Data: ${errMsg});
  //       setShowMessage(true);
  //     } finally {
  //       setLoading(false);
  //     }
  //   }, 2000);
  // }



  const customStyles = {
    headCells: {
      style: {
        height: "clamp(50px, 5vw, 56px)",
        background: "transparent",
        opacity: "1",
        textAlign: "center",
        justifyContent: "center",
        border: "none",
        color: "var(--text-color-1)",
        fontFamily: "var(--font-family)",
        fontWeight: "var(--font-weight-medium)",
        fontSize: "clamp(var(--font-size-medium), 0.8vw, calc(var(--font-size-medium) + 2px))",
      },
    },
    cells: {
      style: {
        height: "clamp(50px, 6vw, 66px)",
        justifyContent: "center",
        textAlign: "center",
        background: "transparent",
        borderTop: "var(--standered-border)",
        borderRight: "none",
        color: "var(--text-color-1)",
        fontFamily: "var(--font-family)",
        fontWeight: "var(--font-weight-regular)",
        fontSize: "clamp(var(--font-size-small), 0.8vw, calc(var(--font-size-small) + 2px))",
      },
    },
  };

  const toggleDropdown = (id) => {
    setOpenDropdownId((prevId) => (prevId === id ? null : id));
  };

  const handleAction = (action, row) => {
    console.log(`Action: ${action} triggered for row:`, row);
    switch (action) {
      // case "edit":
      //   handleEdit(row);
      //   setOpenDropdownId(null);
      //   break;
      // case "Cancel":
      //   // handleCancel(row);
      //   setOpenDropdownId(null);
      //   break;
      // case "delete":
      //   // handleDelete(row);
      //   confirmDelete(row);
      //   setOpenDropdownId(null);
      //   break;
      case "view":
        handleView(row);
        setOpenDropdownId(null);
        break;
      default:
        break;
    }
  };

  const confirmDelete = (row) => {
    setCurrentRowId(row._id);
    setShowConfirm(true);
  };

  const cancelDelete = () => {
    setShowConfirm(false);
  };

  const handleEdit = (row) => {
    row.status !== "refunded" && navigate("/E-Commerce/All-Orders/Edit-Orders", { state: row });
  };

  const handleView = (row) => {
    navigate("/E-Commerce/All-Failed-Orders/View-Failed-Order", { state: row });
  };

  const handleDelete = () => {
    console.log(`Deleting item with ID: ${currentRowId}`);
    if (currentRowId) {
      deleteItem(currentRowId);
    }
  };

  const deleteItem = async (id) => {
    setIsLoading(true);
    setIsActive(true);

    try {
      let successMessage = "Order deleted successfully!";
      //console.log(`Attempting to delete item with ID: ${id}`);

      // const response = await fetch(`${Url}/api/v1/productTag/${id}`, {
      //   method: "DELETE",
      // });

      // if (!response.ok) {
      //   throw new Error("Network response was not ok");
      // }

      // const responseData = await response.json();
      // console.log(`Delete response: `, responseData);
      // console.log(`Selection with ID ${id} deleted successfully.`);

      // setData((prevItems) => prevItems.filter((item) => item._id !== id));

      setToastMessage(successMessage);
      setShowMessage(true);

      fetchTableData();
    } catch (error) {
      let errorMessage = "Failed to delete the selection. Please try again.";
      console.error("Error deleting item:", error);
      setToastMessage(errorMessage);
      setShowMessage(true);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
        setIsActive(false);
      }, 5000);
      setShowConfirm(false);
    }
  };

  /* --- Function to Handle Display of Confirmation Dialogue Box of Delete Action --- */
  const handleDeleteClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      cancelDelete();
      // cancelSelectedDelete();
      // cancelDuplicate();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleDeleteClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleDeleteClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      !event.target.closest(".dropdown-menu") &&
      !event.target.closest(".bar-icon")
    ) {
      setOpenDropdownId(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const shimmerRows = Array.from({ length: 10 }, (_, index) => ({
    isShimmer: true,
    id: `shimmer-${index}`,
  }));


  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 1500);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 1500);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const OrdersColumns = [
    {
      name: (
        <input
          type="checkbox"
          style={{ margin: 0 }}
          onChange={(e) => console.log("All selected:", e.target.checked)}
        />
      ),
      cell: (row) =>
        loading ? (
          <ShimmerLoader width="20px" height="20px" />
        ) : (
          <input
            type="checkbox"
            style={{ margin: 0 }}
            onChange={(e) => console.log("Selected:", row, e.target.checked)}
          />
        ),
      ignoreRowClick: true,
      width: "50px",
      wrap: true,
    },
    {
      name: "ID",
      selector: (row) =>
        loading ? (
          <ShimmerLoader width="30px" height="22.5px" borderRadius="10px" />
        ) : (
          row.uid
        ),
      minWidth: "70px",
      maxWidth: "90px",
      wrap: true,
    },
    {
      name: "Customer",
      selector: (row) => row.billing?.first_name && row.billing?.last_name
        ? `${row.billing.first_name} ${row.billing.last_name}`
        : "N/A",
      minWidth: "150px",
      maxWidth: "250px",
      cell: (row) => (
        loading ? (
          <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
        ) : (
          <div style={{
            whiteSpace: "normal",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            maxHeight: "44px",
          }}>
            {row.billing?.first_name && row.billing?.last_name
              ? `${row.billing.first_name} ${row.billing.last_name}`
              : "N/A"}
          </div>
        )
      ),
      wrap: true,
    },
    {
      name: "Order Date",
      cell: (row) => {
        if (loading) {
          return (
            <ShimmerLoader width="120px" height="22.5px" borderRadius="20px" />
          );
        }
        const { formattedDate, formattedTime, hoursAgo, showYesterday } =
          formatOrderDate(row.createdAt);
        return (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start",
              alignItems: "center",
              overflow: "hidden",
              textOverflow: "ellipsis",
              padding: "5px 10px",
              whiteSpace: "normal",
            }}
          >
            {hoursAgo || showYesterday ? (
              <span>{hoursAgo || "Yesterday"}</span>
            ) : (
              <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "5px"
              }}>
                <span>{formattedDate}</span>
                {/* <span
                  style={{
                    fontSize: "12px",
                    color: "#888",
                    marginLeft: "6px",
                  }}
                >
                  {formattedTime}
                </span> */}
              </div>
            )}
          </div>
        );

      },
      minWidth: "140px",
      maxWidth: "140px",
      wrap: true,
    },
    {
      name: isSmallScreen ? "Payment" : "Payment Method",
      cell: (row) => {
        if (loading) {
          return (
            <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
          );
        }

        const rawMethod = row.payment_method?.toLowerCase() || "N/A";

        // Custom mapping for known payment methods
        const methodMap = {
          "cybersource_credit_card": "Credit Card",
          "credit-card": "Credit Card",
          "credit card": "Credit Card",
          "acima_credit": "Acima Leasing",
          "paypal": "PayPal",
          "wc_chargeafter_gateway": "Progressive Leasing",
        };

        // Format fallback
        const formatPaymentMethod = (method) =>
          method
            .replace(/-/g, " ")
            .replace(/\b\w/g, (char) => char.toUpperCase());

        const formattedMethod =
          rawMethod in methodMap
            ? methodMap[rawMethod]
            : rawMethod !== "N/A"
              ? formatPaymentMethod(rawMethod)
              : "N/A";

        return (
          <div>

            {isSmallScreen && (row.status === "refunded" && row.refund_status === "full" ? (
              <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-start"
              }}>
                <span style={{ textDecoration: "line-through" }}>
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                  }).format(row.total)}
                </span>{" "}
                <span style={{ fontWeight: "600", color: "#595959" }}>$0</span>
              </div>
            ) : row.refund_status === "partial" ? (
              <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-start"
              }}>
                <span style={{ textDecoration: "line-through" }}>
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                  }).format(row.total_refunded_amount + (row.total))}
                </span>{" "}
                <span style={{ fontWeight: "600", color: "#595959" }}>
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                  }).format(row.total)}
                </span>
              </div>
            ) : (
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(row.total)
            ))}
            <Tooltip title={formattedMethod}>
              <div
                style={{
                  padding: "5px 10px",
                  whiteSpace: "normal",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "4px",
                  maxWidth: "100%",
                }}
              >
                {formattedMethod}
              </div>
            </Tooltip>
          </div>
        );
      },
      minWidth: "140px",
      maxWidth: "225px",
      wrap: true,
    },

    {
      name: "Amount",
      selector: (row) =>
        loading ? (
          <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
        ) : row.status === "refunded" && row.refund_status === "full" ? (
          <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "flex-start"
          }}>
            <span style={{ textDecoration: "line-through" }}>
              {new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(row.total)}
            </span>{" "}
            <span style={{ fontWeight: "600", color: "#595959" }}>$0</span>
          </div>
        ) : row.refund_status === "partial" ? (
          <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "flex-start"
          }}>
            <span style={{ textDecoration: "line-through" }}>
              {new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(row.total_refunded_amount + (row.total))}
            </span>{" "}
            <span style={{ fontWeight: "600", color: "#595959" }}>
              {new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(row.total)}
            </span>
          </div>
        ) : (
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
          }).format(row.total)
        ),
      minWidth: "150px",
      maxWidth: "190px",
      wrap: true,
      omit: isSmallScreen
    },
    {
      name: "State",
      cell: (row) => {
        if (loading) {
          return <ShimmerLoader width="90px" height="22.5px" borderRadius="20px" />;
        }
        const origin = row.billing?.state || "N/A";
        return (
          <Tooltip title={origin}>
            <div
              style={{
                padding: "5px 10px",
                whiteSpace: "normal",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "flex",
                flexWrap: "wrap",
                gap: "4px",
                maxWidth: "100%",
              }}
            >
              {origin}
            </div>
          </Tooltip>
        );
      },
      minWidth: "90px",
      maxWidth: "165px",
      wrap: true,
    },
    {
      name: "Status",
      wrap: true,
      cell: (row) => {
        if (loading) {
          return (
            <ShimmerLoader width="90px" height="22.5px" borderRadius="20px" />
          );
        }
        let textColor;
        let backgroundColor;
        let stockLabel;
        switch (row.status) {
          case "processing":
            textColor = "#3A7D99";
            backgroundColor = "#3A7D9910";
            stockLabel = "Processing";
            break;
          case "pending":
            textColor = "#D6B656";
            backgroundColor = "#D6B65610";
            stockLabel = "Pending";
            break;
          case "cancelled":
            textColor = "#B45A67";
            backgroundColor = "#B45A6710";
            stockLabel = "Canceled";
            break;
          case "failed":
            textColor = "#A33D4A";
            backgroundColor = "#A33D4A10";
            stockLabel = "Failed";
            break;
          case "pending":
            textColor = "#F4B074";
            backgroundColor = "#F4B07410";
            stockLabel = "Pending";
            break;
          case "on-hold":
            textColor = "#6C757D";
            backgroundColor = "#6C757D10";
            stockLabel = "On Hold";
            break;
          case "refunded":
            textColor = "#835D97";
            backgroundColor = "#835D9720";
            stockLabel = "Refunded";
            break;
          case "processing":
            textColor = "#F4B074";
            backgroundColor = "#F4B07410";
            stockLabel = "Processing";
            break;
          case "delivered":
            textColor = "#4F8057";
            backgroundColor = "#4F805710";
            stockLabel = "Delivered";
            break;
          case "completed":
            textColor = "#4F8057";
            backgroundColor = "#4F805710";
            stockLabel = "Completed";
            break;
          case "approved":
            textColor = "#28A745";        // Green text
            backgroundColor = "#28A74510"; // Light green background (10% opacity)
            stockLabel = "Approved";
            break;
          default:
            textColor = "#999";
            backgroundColor = "#E0E0E010";
            stockLabel = "Unknown";
        }
        return (
          <div
            style={{
              color: textColor,
              backgroundColor: backgroundColor,
              padding: "5px 10px",
              borderRadius: "5px",
              display: "inline-block",
              fontWeight: 600,
              whiteSpace: "normal",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "flex",
              flexWrap: "wrap",
              gap: "4px",
              maxWidth: "100%",
            }}
          >
            {stockLabel}
          </div>
        );
      },
      minWidth: "100px",
      maxWidth: "140px",
    },
    {
      name: "Action",
      cell: (row) =>
        loading ? (
          <ShimmerLoader width="60px" height="22.5px" />
        ) : (
          <div key={row._id} style={{ position: "relative" }}>
            <img
              src={actionIcon}
              alt="Action Icon"
              width="40"
              height="40"
              style={{ cursor: "pointer", margin: 0, padding: 0 }}
              className={`bar-icon ${openDropdownId === row._id ? "rotated" : ""
                }`}
              onClick={() => toggleDropdown(row._id)}
            />
            {openDropdownId === row._id && (
              <div className={`dropdown-menu show animate-dropdown-left`}>
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  <li
                    key="view"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      padding: "5px 10px",
                      border: "none",
                    }}
                    onClick={() => handleAction("view", row)}
                  >
                    <IoEyeOutline style={{ marginRight: "12px" }} className="icon-img-updated" />
                    View
                  </li>
                  {/* <li
                    key="edit"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      padding: "5px 10px",
                      border: "none",
                    }}
                    onClick={() => handleAction("edit", row)}
                  >
                    <FiEdit style={{ marginRight: "12px" }} className="icon-img-updated" />
                    Edit
                  </li>
                  <li
                    key="cancel"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      padding: "5px 10px",
                      border: "none",
                    }}
                    onClick={() => handleAction("cancel", row)}
                  >
                    <RiDeleteBin6Line style={{ marginRight: "12px" }} className="icon-img-updated" />
                    Cancel
                  </li>
                  <li
                    key="delete"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      padding: "5px 10px",
                      border: "none",
                    }}
                    onClick={() => handleAction("delete", row)}
                  >
                    <RiDeleteBin6Line style={{ marginRight: "12px" }} className="icon-img-updated" />
                    Delete
                  </li> */}
                </ul>
              </div>
            )}
          </div>
        ),
      width: "90px",
    },
  ];



  const disabledDate = (current) => {
    return current && current > new Date();
  };

  const chartSeries = [
    {
      name: "Direct",
      data: [44],
    },
    {
      name: "SEO",
      data: [76],
    },
    {
      name: "Ads",
      data: [35],
    },
    {
      name: "Reference",
      data: [69],
    },
  ];

  const chartOptions = {
    chart: {
      type: "bar",
      height: "150px",
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        columnWidth: "55%",
        borderRadius: 5,
        borderRadiusApplication: "end",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories: [""],
    },
    yaxis: {},
    fill: {
      opacity: 1,
    },
    colors: ["#77baf8", "#9ed2ff", "#5285b4", "#78abda"],
  };


  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    fetchTableData(pageNumber, 100, filtersApplied ? savedFilters : null);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      const newPage = currentPage - 1;
      setCurrentPage(newPage);
      fetchTableData(newPage, 100, filtersApplied ? savedFilters : null);
    }
  };

  const handleNextPage = () => {
    if (currentPage < pagination?.totalPages) {
      const newPage = currentPage + 1;
      setCurrentPage(newPage);
      fetchTableData(newPage, 100, filtersApplied ? savedFilters : null);
    }
  };


  const placeholderRows = Array(7)
    .fill({ uid: "", name: "", image: "" })
    .map((row, index) => ({ ...row, uid: `placeholder-${index}` }));
  const displayedData = filteredData; // or use 'data' if you're not filtering


  /* --- Function for representing numbers & currency in standard way --- */
  const formatNumber = (num) => {
    if (num === 0 || num === "0") return "0";
    if (num === null || num === undefined || num === "") return "N/A";
    const formattedNum = parseFloat(num).toFixed(2);
    return new Intl.NumberFormat("en-US").format(formattedNum);
  };

  const formatCurrency = (amount) => {
    if (!amount) return "$0.00";
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(amount);
  };

  /* --- Overview Header Cards Handling --- */
  const OrderCardData = [
    {
      title: "Total Orders",
      value: loading ? (
        <ShimmerLoader width="75px" height="21.5px" borderRadius="5px" />
      ) : (
        formatNumber(cardData?.totalOrders || "0")
      ),
      icon: <FaShoppingCart />,
    },
    {
      title: "Delivered Orders",
      value: loading ? (
        <ShimmerLoader width="75px" height="21.5px" borderRadius="5px" />
      ) : (
        formatNumber(countData?.completed ?? "0")
      ),
      icon: <FaShippingFast />,
    },
    {
      title: "Cancelled Orders",
      value: loading ? (
        <ShimmerLoader width="75px" height="21.5px" borderRadius="5px" />
      ) : (
        formatNumber(countData?.cancelled ?? "0")
      ),
      icon: <FaTimesCircle />,
    },
    {
      title: "Failed Orders",
      value: loading ? (
        <ShimmerLoader width="75px" height="21.5px" borderRadius="5px" />
      ) : (
        formatNumber(countData?.failed ?? "0")
      ),
      icon: <FaTimesCircle />,
    },
    {
      title: "Processing Orders",
      value: loading ? (
        <ShimmerLoader width="75px" height="21.5px" borderRadius="5px" />
      ) : (
        formatNumber(countData?.processing ?? "24")
      ),
      icon: <FaClipboardList />,
    },
    {
      title: "New Customers",
      value: loading ? (
        <ShimmerLoader width="75px" height="21.5px" borderRadius="5px" />
      ) : (
        formatNumber(data?.totalItemsSold || "12")
      ),
      icon: <FaUserPlus />,
    },
    {
      title: "Average Sale",
      value: loading ? (
        <ShimmerLoader width="75px" height="21.5px" borderRadius="5px" />
      ) : (
        formatCurrency(avgSaleData || "1209")
      ),
      icon: <FaHandHoldingUsd />,
    },
  ];

  return (
    <div className="AllOrderPage">
      {/* <div className="Analytics-Section">
        <div className="LeftSide-Analytics">
          {Array.isArray(OrderCardData) && OrderCardData.length > 0 ? (
            OrderCardData.map((item, index) => (
              <div key={index} className="Order-Row01-Card">
                <OrderViewCard
                  title={item.title}
                  value={item.value}
                  icon={item.icon}
                />
              </div>
            ))
          ) : (
            <p>Loading data...</p>
          )}
        </div>
      </div> */}

      <div className="Filters-Section">
        <Accordion allowZeroExpanded className="accordion">
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>Filters</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              {/* First Row: Labels */}
              <div className="filter-row-01">
                <div className="filter-label">Order Id</div>
                <div className="filter-label">Phone No</div>
                <div className="filter-label">Email</div>
                <div className="filter-label">Customer</div>
              </div>

              {/* Second Row: React Select Fields */}
              <div className="filter-row-02">
                <InputField
                  value={orderId}
                  name="orderId"
                  onChange={(e) =>
                    handleFilterChange(e.target.value, "orderId")
                  }
                  placeholder="Enter Order ID"
                />
                <InputField
                  value={phoneNo}
                  name="phoneNo"
                  onChange={(e) =>
                    handleFilterChange(e.target.value, "phoneNo")
                  }
                  placeholder="Enter Phone Number"
                />
                <InputField
                  value={email}
                  name="email"
                  onChange={(e) => handleFilterChange(e.target.value, "email")}
                  placeholder="Enter Email"
                />
                 <InputField
                  value={customer}
                  name="customer"
                  onChange={(e) => handleFilterChange(e.target.value, "customer")}
                  placeholder="Enter Customer Name"
                />
             
              </div>

              {/* Third Row: Labels */}
              <div className="filter-row-03">
                {/* <div className="filter-label">Product Name</div> */}
                <div className="filter-label">Date</div>
                <div className="filter-label">Payment Method</div>
              </div>

              {/* Fourth Row: React Select Fields */}
              <div className="filter-row-02">
                {/* <InputField /> */}
               
                <div className="Order-filter-date-wrapper">
                  <RangePicker
                    format="YYYY-MM-DD"
                    onChange={(dates) => handleFilterChange(dates, "date")}
                    value={dateRange}
                    style={{ width: "100%", height: "clamp(40px, 6vh, 48px)" }}
                    disabledDate={disabledDate}
                  />
                </div>
                <div className="custom-dropdown-wrapper-Filter">
                  <CustomDropdown
                    placeholder={"Select Payment Method"}
                    options={payMethodsOptions}
                    selectedOption={
                      payMethodsOptions.find(
                        (method) => method.value === selectedMethod
                      )?.value || "Select a Payment Method"
                    }
                    handleOptionChange={(value) =>{
                      handleFilterChange(value, "paymentMethod")}
                    }
                    dropdownWidth={'100%'}
                    dropdownMarginBottom="13px"
                    backgroundColor="var(--third-layer-bg)"
                    optionsWidth={'100%'}
                    optionsBackgroundColor="var(--third-layer-bg)"
                    optionsHeight={75}
                    dropdownSelectedStyle="7px"
                    dropdownHeight={`clamp(38px, 6vh, 46px)`}
                  />
                </div>
              </div>

              {/* Fifth Row: Apply Filters Button */}
              <div className="filter-row-04">
                {!filtersApplied ? (
                  <button onClick={handleFilters} type="submit" className="apply_filter_btn">
                    {filterLoading ? <div
                      style={{ borderTop: "4px solid white" }}
                      className="btn-loader-Publish"
                    ></div> : "Apply Filter"}
                  </button>
                ) : (
                  <>
                    <CustomBtn
                      label="Reset"
                      withIcon={true}
                      iconType="reset"
                      className="ResetBtn-OrderPage"
                      onClick={handleResetFilters}
                      type="button"
                    />
                    <button onClick={handleFilters} type="submit" className="apply_filter_btn">
                      {filterLoading ? <div
                        style={{ borderTop: "4px solid white" }}
                        className="btn-loader-Publish"
                      ></div> : "Apply Filter"}
                    </button>
                  </>
                )}

              </div>
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
      </div>

      <div className="Orders-Table-Data">
        <div>
          <DataTable
            columns={OrdersColumns}
            data={loading ? shimmerRows : filteredData}
            customStyles={customStyles}
          />
          <ElipticalPagenation
            activePageIndex={currentPage}
            totalPages={pagination?.totalPages}
            onPrevPage={handlePrevPage}
            onNextPage={handleNextPage}
            onPageChange={handlePageChange}
          />
          {filtersApplied && <div></div>}
        </div>
      </div>

      {/* --- (PopUp) To Handle Confiramtion for Delete Operation of Single Category --- */}
      {showConfirm && (
        <div className="confirmation-modal">
          <div className="Cat-modal-content" ref={modalRef}>
            <CiWarning className="warning-icon" />
            <div className="Delete-Heading">Warning</div>
            <div className="Delete-Content">
              Are you sure you want to delete this Order? <br />
              This action cannot be undone.
            </div>
            <div className="separator-line"></div>
            <div className="modal-actions">
              <button
                className="Cat-Delete-btn btn-secondary"
                onClick={cancelDelete}
              >
                Cancel
              </button>

              <div className="SubmitBtn">
                <CustomBtn
                  label={
                    isLoading ? (
                      <div className="btn-loader-Category"></div>
                    ) : (
                      "Confirm"
                    )
                  }
                  className={`Cat-Delete-btn btn-danger ${isActive ? "active" : ""
                    }`}
                  disabled={isLoading}
                  onClick={handleDelete}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      <BottomToust
        showMessage={showMessage}
        message={toastMessage}
        handleCloseMessageModal={() => handleCloseMessageModal()}
      />
    </div>
  );
};

export default AllFailedOrders;